import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ro from './translations/ro';
import ru from './translations/ru';
import { ru as ruLang, ro as roLang } from 'date-fns/locale';

const resources = {
  ro,
  ru,
};
type Locales = {
  [type: string]: Locale;
};

export const locales: Locales = {
  ro: roLang,
  ru: ruLang,
};

export const availableLanguages = Object.keys(resources);
export const language = i18n.language;

i18n.use(initReactI18next).use(LanguageDetector).init({
  resources,
  defaultNS: 'translations',
  fallbackLng: 'ru',
});
